import store from 'state/store';

import {
  finishSpinnerRequestAction,
  startSpinnerRequestAction,
} from './actions';

const getBaseFetch = () => {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return null;
  }

  if (!window.__backendRequestSpinnerOriginalFetch) {
    window.__backendRequestSpinnerOriginalFetch = window.fetch.bind(window);
  }

  return window.__backendRequestSpinnerOriginalFetch;
};

const requestShouldBeTracked = (requestUrl) => {
  if (!requestUrl) {
    return false;
  }

  if (requestUrl.startsWith('/')) {
    return true;
  }

  try {
    const parsedUrl = new URL(requestUrl, window.location.origin);

    return parsedUrl.hostname === window.location.hostname;
  } catch (error) {
    return false;
  }
};

const getRequestUrl = (resource) => {
  if (typeof resource === 'string') {
    return resource;
  }

  if (resource && resource.url) {
    return resource.url;
  }

  return '';
};

export const trackedFetch = (...args) => {
  const baseFetch = getBaseFetch();

  if (!baseFetch) {
    return Promise.reject(new Error('window.fetch is not available'));
  }

  const requestUrl = getRequestUrl(args[0]);
  const trackRequest = requestShouldBeTracked(requestUrl);

  if (trackRequest) {
    store.dispatch(startSpinnerRequestAction());
  }

  return baseFetch(...args).finally(() => {
    if (trackRequest) {
      store.dispatch(finishSpinnerRequestAction());
    }
  });
};

const installTrackedFetch = () => {
  const baseFetch = getBaseFetch();

  if (!baseFetch || window.__backendRequestSpinnerInstalled) {
    return;
  }

  window.fetch = trackedFetch;
  window.__backendRequestSpinnerInstalled = true;
};

export default installTrackedFetch;
